import { Injectable } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ContentService as NewContentService, DsbStep as NewDsbStep } from '../../app/services/content.service';

export interface DsbStep extends NewDsbStep {}

@Injectable({
    providedIn: 'root',
})
export class ContentService extends NewContentService {
    public stepper!: MatStepper;
}
